import firebase from "firebase";

const config = {
    apiKey: process.env.REACT_APP_apiKey,
    authDomain: process.env.REACT_APP_authDomain,
    databaseURL: process.env.REACT_APP_databaseURL,
    projectId: process.env.REACT_APP_projectId,
    storageBucket: process.env.REACT_APP_storageBucket,
    messagingSenderId: process.env.REACT_APP_messagingSenderId,
    appId: process.env.REACT_APP_appId,
    measurementId: process.env.REACT_APP_measurementId,
};



// Initialize Firebase
// export default (!firebase.apps.length
//   ? firebase.initializeApp(config)
//   : firebase.app());
firebase.initializeApp(config)
firebase.analytics();
export default firebase